/** Приоритет заявки / строки: 1 (мин.) … 5 (макс.), по умолчанию 3. */
export const PRIORITY_MIN = 1
export const PRIORITY_MAX = 5
export const PRIORITY_DEFAULT = 3

const PRIORITY_LABELS: Record<number, string> = {
  1: 'минимальный',
  2: 'низкий',
  3: 'обычный',
  4: 'высокий',
  5: 'максимальный',
}

/** Подпись для option/select: «3 — обычный». */
export function priorityOptionLabel(value: number): string {
  const label = PRIORITY_LABELS[value]
  return label ? `${value} — ${label}` : String(value)
}

/** Краткая подпись для списков: «P3 · обычный». */
export function priorityShortLabel(value: number): string {
  const v = Math.min(PRIORITY_MAX, Math.max(PRIORITY_MIN, Number(value) || PRIORITY_DEFAULT))
  const label = PRIORITY_LABELS[v]
  return label ? `P${v} · ${label}` : `P${v}`
}

export const PRIORITY_VALUES = [1, 2, 3, 4, 5] as const

export function clampPriority(value: unknown): number {
  return Math.min(PRIORITY_MAX, Math.max(PRIORITY_MIN, Number(value) || PRIORITY_DEFAULT))
}
